import type { EventDto } from '../dto/event.dto'
import type { Event } from '@/domain/entities/event.entity'
import { mapDate } from './base.mapper'

export function mapEventDtoToEntity(dto: EventDto): Event {
  return {
    id: dto._id,
    event_slug: dto.event_slug,
    event_title: dto.event_title,
    event_preview: dto.event_preview,
    event_locale: dto.event_locale,
    event_views: dto.event_views ?? 0,
    event_date: mapDate(dto.event_date),
    event_cover_image: dto.event_cover_image,
    event_author: dto.event_author,
    event_content: dto.event_content ?? [],
    event_created_at: mapDate(dto.event_created_at),
    event_modified_at: mapDate(dto.event_modified_at),
  }
}

export function mapEventDtoArrayToEntities(dtos: EventDto[]): Event[] {
  return dtos.map(mapEventDtoToEntity)
}

